import { Model } from 'app/model/backendmodel';
import { Activity, Link, Criteria } from '../../pipeline/activity';
import { DependencyConditionContext } from 'app/interfaces/copilot.pipeline.action.types';

export class ActivityDependencyAdapter {
    public static convertDependencyConditionToCriteria(dependencyCondition: string): Criteria {
        switch (dependencyCondition) {
            case 'Completed':
                return Criteria.COMPLETED;
            case 'Failed':
                return Criteria.FAILURE;
            case 'Succeeded':
                return Criteria.SUCCESS;
            case 'Skipped':
                return Criteria.SKIPPED;
            default:
                return Criteria.INVALID;
        }
    }

    public static convertCriteriaToDependencyCondition(criteria: Criteria): string {
        switch (criteria) {
            case Criteria.COMPLETED:
                return 'Completed';
            case Criteria.FAILURE:
                return 'Failed';
            case Criteria.SUCCESS:
                return 'Succeeded';
            case Criteria.SKIPPED:
                return 'Skipped';
            default:
                return '';
        }
    }

    public static convertDependencyConditionToFabricContext(dependencyCondition: string): DependencyConditionContext {
        switch (dependencyCondition) {
            case 'Completed':
                return DependencyConditionContext.Completion;
            case 'Failed':
                return DependencyConditionContext.Failure;
            case 'Succeeded':
                return DependencyConditionContext.Success;
            case 'Skipped':
                return DependencyConditionContext.Skipped;
            default:
                return undefined;
        }
    }

    public static convertDependencyConditionContextToCriteria(
        dependencyCondition: DependencyConditionContext
    ): Criteria {
        switch (dependencyCondition) {
            case DependencyConditionContext.Completion:
                return Criteria.COMPLETED;
            case DependencyConditionContext.Failure:
                return Criteria.FAILURE;
            case DependencyConditionContext.Success:
                return Criteria.SUCCESS;
            case DependencyConditionContext.Skipped:
                return Criteria.SKIPPED;
            default:
                return Criteria.INVALID;
        }
    }

    public toResource(activity: Activity): Model.ActivityDependency[] {
        const dependsOn: Model.ActivityDependency[] = [];
        activity.fromLinks.forEach((link: Link) => {
            const existingDependsOn = dependsOn.filter(
                (dependency: Model.ActivityDependency) => dependency.activity === link.fromActivity.name
            )[0];
            const dependencyCondition = ActivityDependencyAdapter.convertCriteriaToDependencyCondition(link.criteria);
            if (existingDependsOn) {
                existingDependsOn.dependencyConditions.push(dependencyCondition);
            } else {
                if (link.fromActivity.name) {
                    dependsOn.push({
                        activity: link.fromActivity.name,
                        dependencyConditions: [dependencyCondition]
                    });
                } else {
                    throw new Error('Invalid link: ' + JSON.stringify(link));
                }
            }
        });

        return dependsOn;
    }
}
